import { gql } from "@/__generated__/gql";

export const REPLACE_USER_SOCIALS_MUTATION = gql(`
  mutation ReplaceUserSocials(
    $userId: ID!
    $socials: [SocialMediaHandleInput!]!
  ) {
    replaceUserSocialsMutation(input: {
      userId: $userId
      socials: $socials
    }) {
      clientMutationId
      socials {
        id
        handle
        platform {
          id
          name
          baseUrl
          icon {
            url(size: 100)
          }
        }
      }
      errors {
        title
        message
      }
    }
  }
`);
